import { connect } from 'react-redux'
import Helmet from './Helmet'
import { defaultCurrency } from 'store/currency'
import { billingCycleId } from 'constants/'

const mapStateToProps = ({ course, support, currency }) => {
  const initialCurrency = currency.initialCurrency
  const annual = support?.SubscriptionTypePrices?.find(item => item.BillingCycle === billingCycleId.annual)
  const monthly = support?.SubscriptionTypePrices?.find(item => item.BillingCycle === billingCycleId.monthly)
  return {
    Price: initialCurrency === defaultCurrency ? course.Course.Price : course.Course.AlternativePrice,
    Id: course.Course.Id,
    initialCurrency: currency.initialCurrency,
    annualPrice: initialCurrency === defaultCurrency ? annual?.AlternativePrice : annual?.Price,
    monthlyPrice: initialCurrency === defaultCurrency ? monthly?.AlternativePrice : monthly?.Price
  }
}

export default connect(mapStateToProps, null)(Helmet)
